const stat = [
    {
        id: "1",
        chars: "500",
        shiptype: "3000"
    }
]

export default stat